import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import BaseIndicator from './BaseButton';

type Props = {
  uuid: string;
};

const ViewDetailsButton = ({ uuid }: Props) => {
  const location = useLocation();
  const { tr } = useTranslation();
  const history = useHistory();

  const handleOnClick = useCallback(() => {
    let path = location.pathname;
    // need to check and see if the panel is already open - if so, we need
    // strip the existing uuid off the route before appending the new one
    if (path.includes('/item/')) {
      path = path.split('/item/')[0];
    }

    // check for trailing slash
    path = path.slice(-1) === '/' ? path.slice(0, -1) : path;

    history.push({
      pathname: `${path}/item/${uuid}/comments`,
      state: { modal: location.state?.modal, preventPreviousRouteChange: location.state?.modal },
    });
  }, []);

  return (
    <BaseIndicator
      icon="comment"
      onClick={handleOnClick}
      tooltip={tr('perform.meeting_items.view_details_button.tooltip')}
      qaTest="meeting-item-actions-view-item-btn"
    />
  );
};

export default ViewDetailsButton;
